import React from 'react';
import {
  Col,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';
import Text from '../../../components/Text';

export default function LeadsPayrollView(props) {
  return (
    <div>
      <FormGroup>
        <Row>
          <Col sm="auto" className="label-main">
            <Label htmlFor="payrollType">
              <Text value="How do you receive your pay" />
            </Label>
          </Col>
        </Row>
        <Input
          type="select"
          name="payrollType"
          id="payrollType"
          value={props.formData.payrollType}
          onChange={props.onChange}
          invalid={props.validations.payrollType?.isInvalid}
        >
          <option value="">Select an option</option>
          <option key="direct" value="D">Direct Deposit</option>
          <option key="paper" value="P">Paper Check</option>
        </Input>
        <FormFeedback>{ props.validations.payrollType?.message }</FormFeedback>
      </FormGroup>
    </div>
  );
}
